import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { ConfigService } from 'src/app/tools/services/config.service';
import { SalesReportsService } from 'src/app/assabil-sales/services/sales-reports-service';
import { Sorder } from 'src/app/assabil-sales/models/entities/s-order';
import { SorderLine } from 'src/app/assabil-sales/models/entities/s-order-line';
import { SalesTransactionsService } from 'src/app/assabil-sales/services/sales-transactions-service';
import { SorderPipe } from 'src/app/assabil-sales/pipes/sorder-pipe';
import { Sinvoice } from 'src/app/assabil-sales/models/entities/s-invoice';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { SinvoiceLine } from 'src/app/assabil-sales/models/entities/s-invoice-line';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
 

@Component({
    selector: 'sorder-widget',
    templateUrl: './sorder-widget.component.html',
    styleUrls: ['./sorder-widget.component.scss']
})



export class SorderWidgetComponent extends BaseWidget  {


  sorderPipe            : SorderPipe = new SorderPipe();
  
  sorder               : Sorder = new Sorder();
  sorderLineColumns   = [];
  enteredOnly           : boolean = true;


  qColumns  = [
                {'label' : 'Qté commandée',   readOnly : true, background :'#eef5fb'}, 
                {'label' : 'Qté livrée'   ,   readOnly : true, background :'white' },
                {'label' : 'Qté à livrer'   ,   readOnly : false, background :'#eef5fb' }
              ];
 

  sinvoice            : Sinvoice      = new Sinvoice();
  validationStep      : boolean       = false;

              
  constructor(
    public    masterDataService : MasterDataService,
    protected salesTransactionsService: SalesTransactionsService,
    protected toastr            : ToastrService,
    protected leanUtilsService  : LeanUtilsService,
    protected configService     : ConfigService,
    protected salesReportsService: SalesReportsService,
    protected baseService       : BaseService) {
    super(toastr, leanUtilsService);
  }


 //--------------------------------------------------------------------------------------------------------
 setEntity(sorder: Sorder) {
   
  this.sorder = sorder;
  if (sorder.inserted) this.enteredOnly = false

  // if (sorder.returnPo) {
  //   this.qColumns  = [
  //     {'label' : 'Retour Demandé',           readOnly : false, background :'#eef5fb'},  
  //     {'label' : 'Retour Endommagé Demandé', readOnly : false, background :'#faeeee'}, 
  //     {'label' : 'Retour Périmé Demandé',    readOnly : false, background :'#f0dede'}, 

  //     {'label' : 'Retour Validé',            readOnly : true , background :'#eef5fb'}, 
  //     {'label' : 'Retour Endommagé Validé',  readOnly : true , background :'#faeeee'}, 
  //     {'label' : 'Retour Périmé Validé',     readOnly : true , background :'#f0dede'}, 
  //   ];
  // }


   this.masterDataService.loadProductPages(3, true).then(res => {

      if (sorder.sorderLines) {
        for (let sorderLine of sorder.sorderLines) {
          for (let pp of this.masterDataService.salableProductPages) {
            for (let product of pp.products) {
              if (product.productCode == sorderLine.product.productCode) {
                
                // if (! sorder.returnPo) {
                  //product.quantityL[0] = this.leanUtilsService.zeroToNull(Math.floor(sorderLine.quantity / product.purchasePacking)); 
                  product.quantityP[0] = this.leanUtilsService.zeroToNull(Math.floor(sorderLine.quantity / product.salesPacking)); 
                  product.quantityU[0] = this.leanUtilsService.round(sorderLine.quantity - ( this.leanUtilsService.nullToZero(product.quantityP[0]) * product.salesPacking), product.decimalPrecision);

                  product.quantityP[1] = this.leanUtilsService.zeroToNull(Math.floor(sorderLine.deliveredQuantity / product.salesPacking)); 
                  product.quantityU[1] = this.leanUtilsService.round(sorderLine.deliveredQuantity - ( this.leanUtilsService.nullToZero(product.quantityP[1]) * product.salesPacking), product.decimalPrecision);
                // } else {
                //   product.quantityL[0] = this.leanUtilsService.zeroToNull(Math.floor(sorderLine.returnedQuantity / product.purchasePacking)); 
                //   product.quantityP[0] = this.leanUtilsService.zeroToNull(Math.floor((sorderLine.returnedQuantity % product.purchasePacking) / product.loadPacking)); 
                //   product.quantityU[0] = this.leanUtilsService.zeroToNull(sorderLine.returnedQuantity -  (this.leanUtilsService.nullToZero(product.quantityL[0]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[0]) * product.loadPacking));
 
                //   product.quantityL[1] = this.leanUtilsService.zeroToNull(Math.floor(sorderLine.returnedDamagedQuantity1 / product.purchasePacking)); 
                //   product.quantityP[1] = this.leanUtilsService.zeroToNull(Math.floor((sorderLine.returnedDamagedQuantity1 % product.purchasePacking) / product.loadPacking)); 
                //   product.quantityU[1] = this.leanUtilsService.zeroToNull(sorderLine.returnedDamagedQuantity1 -  (this.leanUtilsService.nullToZero(product.quantityL[1]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[1]) * product.loadPacking));
 
                //   product.quantityL[2] = this.leanUtilsService.zeroToNull(Math.floor(sorderLine.returnedDamagedQuantity2 / product.purchasePacking)); 
                //   product.quantityP[2] = this.leanUtilsService.zeroToNull(Math.floor((sorderLine.returnedDamagedQuantity2 % product.purchasePacking) / product.loadPacking)); 
                //   product.quantityU[2] = this.leanUtilsService.zeroToNull(sorderLine.returnedDamagedQuantity2 -  (this.leanUtilsService.nullToZero(product.quantityL[2]) *  product.purchasePacking) - ( this.leanUtilsService.nullToZero(product.quantityP[2]) * product.loadPacking));
 
                // }

                pp.expand = true;
                break;
              }
            }
          }
        }

        for (let sorderDelivery of sorder.sorderDeliveries) {
          for (let pp of this.masterDataService.salableProductPages) {
            for (let product of pp.products) {
              if (product.productCode == sorderDelivery.productCode) {
                
                  product.quantityP[1] = Math.floor(sorderDelivery.quantity / product.salesPacking);  
                  product.quantityU[1] = sorderDelivery.quantity - ( this.leanUtilsService.nullToZero(product.quantityP[1]) * product.salesPacking);   
                  
                  // product.quantityP[2] = Math.floor(sorderDelivery.returnedDamagedQuantity1 / product.salesPacking);  
                  // product.quantityU[2] = sorderDelivery.returnedDamagedQuantity1 - ( this.leanUtilsService.nullToZero(product.quantityP[4]) * product.salesPacking);                 

                  // product.quantityP[3] = Math.floor(sorderDelivery.returnedDamagedQuantity2 / product.salesPacking);  
                  // product.quantityU[3] = sorderDelivery.returnedDamagedQuantity2 - ( this.leanUtilsService.nullToZero(product.quantityP[5]) * product.salesPacking);                 

                
                pp.expand = true;
                break;
              }
            }
          }
        }
      }
      
   })
  }
 //--------------------------------------------------------------------------------------------------------

  //--------------------------------------------------------------------------------------------------------
  getEntity(){
    return this.sorder;
  }
  //--------------------------------------------------------------------------------------------------------

  closeSorder(){
        this.salesTransactionsService.sorderClose(this.sorder.sorderCode).then(res => {
          this.sorder = res; 
          this.leanUtilsService.success();
          return;
      })
  }

  //--------------------------------------------------------------------------------------------------------
  saveRow() : Promise<Sorder>{
    
    this.enteredOnly = true;

    let newSorderLines : SorderLine[] = [];

    for (let pp of this.masterDataService.salableProductPages) {
      for (let product of pp.products) {
        let found : boolean = false;
        for (let sorderLine of this.sorder.sorderLines) {
          if (product.productCode == sorderLine.product.productCode) {
            found = true;
            if ( (! product.quantityL[0]) &&(! product.quantityP[0]) && (! product.quantityU[0]) 
              && (! product.quantityL[1]) &&(! product.quantityP[1]) && (! product.quantityU[1]) 
              && (! product.quantityL[2]) &&(! product.quantityP[2]) && (! product.quantityU[2]) ) {
              sorderLine.deleted = true;
            } else {
              // if (! this.sorder.returnPo) {
                sorderLine.quantity = this.getQuantity(product, 0);
              // } else {
              //   sorderLine.returnedQuantity        = this.getQuantity(product, 0);
              //   sorderLine.returnedDamagedQuantity1= this.getQuantity(product, 1);
              //   sorderLine.returnedDamagedQuantity2= this.getQuantity(product, 2);   
              // }
             }
            break;
          }
        }
        if ( (! found) && (   product.quantityL[0]  || product.quantityP[0]  || product.quantityU[0]   
                           || product.quantityL[1]  || product.quantityP[1]  || product.quantityU[1] 
                           || product.quantityL[2]  || product.quantityP[2]  || product.quantityU[2]) ) {
          let newSorderLine : SorderLine = new SorderLine();
          newSorderLine.inserted            = true;
          newSorderLine.product             = new Product();
          newSorderLine.product.productCode = product.productCode;
          // if ( ! this.sorder.returnPo) {
            newSorderLine.quantity                 = this.getQuantity(product, 0); 
          // } else {
          //   newSorderLine.returnedQuantity         = this.getQuantity(product, 0);
          //   newSorderLine.returnedDamagedQuantity1 = this.getQuantity(product, 1);
          //   newSorderLine.returnedDamagedQuantity2 = this.getQuantity(product, 2);
          // } 
          newSorderLines.push(newSorderLine);
        }
      }
    }

    for (let newSorderLine of newSorderLines){
      this.sorder.sorderLines.push(newSorderLine);
    }

    return this.salesTransactionsService.sorderSave(this.sorder);
  }
  //--------------------------------------------------------------------------------------------------------


  edit(b  : boolean) {

    // if ( b ) {
    //   this.sorder.edit    = true;
    //   this.sorder.updated = true;
    //   return;
    // }
      

    // // We are leaving edit mode by Update cancelation or  Create cancelation
    
    // // Create cancelation
    // if (this.sorder.inserted){
    //   this.close();
    //   return;
    // } 

    if ( b ) return;
    // Update cancelation
    this.salesTransactionsService.sorderGet(this.sorder.sorderCode).then(res => {
        this.sorder = res; 
        this.setEntity(this.sorder);
        return;
    })

  }

receptionMode : boolean = false;
//sdeliveryNote : SdeliveryNote

newSdeliveryNote(){
    //let tmp : Sorder = new Sorder();
    //tmp.sorderCode = this.sorder.sorderCode;
    // this.sdeliveryNote                  = new SdeliveryNote();
    // this.sdeliveryNote.sorder           = tmp;
    // this.sdeliveryNote.inserted         = true;

    // this.sdeliveryNote.sdeliveryNoteLines = [];

    if (this.sorder.sorderLines) {
      for (let pp of this.masterDataService.salableProductPages) {
        for (let product of pp.products) {
          product.quantityP[2] = this.leanUtilsService.zeroToNull(0); 
          product.quantityU[2] = this.leanUtilsService.zeroToNull(0);
  
        }
      }
    }

    
    let qte : number = 0;;
    if (this.sorder.sorderLines) {
      for (let sorderLine of this.sorder.sorderLines){
        if(sorderLine.freeGoodLine) continue;

        for (let pp of this.masterDataService.salableProductPages) {
          for (let product of pp.products) {
            if (product.productCode == sorderLine.product.productCode) {
              qte = 0;
              if(this.sorder.sorderDeliveries)
              {
                for (let sod of this.sorder.sorderDeliveries){
                  if (sod.productCode == sorderLine.product.productCode){
                    if(sorderLine.quantity > sod.quantity) qte = sod.quantity;
                    else qte = sorderLine.quantity;
                    break;
                  }
                }
              }

              product.quantityP[2] = this.leanUtilsService.zeroToNull(Math.floor((sorderLine.quantity - qte) / product.salesPacking)); 
              product.quantityU[2] = this.leanUtilsService.zeroToNull((sorderLine.quantity - qte) - ( this.leanUtilsService.nullToZero(product.quantityP[2]) * product.salesPacking));
              break;
            }

          }

        }


        
          // let sdeliveryNoteLine                  : SdeliveryNoteLine = new SdeliveryNoteLine();
          // sdeliveryNoteLine.product              = new Product();
          // sdeliveryNoteLine.product.productCode  = pol.product.productCode;

          // sdeliveryNoteLine.quantity                  = pol.quantity ;
          // sdeliveryNoteLine.returnedQuantity          = pol.returnedQuantity ;
          // sdeliveryNoteLine.returnedDamagedQuantity1  = pol.returnedDamagedQuantity1 ;  
          // sdeliveryNoteLine.returnedDamagedQuantity2  = pol.returnedDamagedQuantity2 ;  

          // this.sdeliveryNote.sdeliveryNoteLines.push(sdeliveryNoteLine);
        }
    }
    this.sinvoice = new Sinvoice();
    this.simulatedInvoice = null;
  
    this.sorder.edit    = true;
    this.sorder.updated = true;



    // if (this.sorder.sorderDeliveries) {
    //   for (let sorderDelivery of this.sorder.sorderDeliveries) {
    //     for (let wtr of this.sdeliveryNote.sdeliveryNoteLines) {
    //       if (wtr.product.productCode == sorderDelivery.productCode){

    //         wtr.movedQuantity1 =  wtr.movedQuantity1 - sorderDelivery.quantity;
    //         if (wtr.movedQuantity1 <0) wtr.movedQuantity1 = 0;

    //         //xxxxx

    //       }
    //     }
    //   }
    //}

    //this.receptionMode = true;
  }

  exitReceptionMode(){
    this.receptionMode = false;

    // In order to reinit ProductPages.product fields
    this.setEntity(this.sorder);
  }


  //------------------------------------------------------------------------------------------------------------
  getQuantity(product: Product, index: number): number {
    let l = product.quantityL[index] ? product.quantityL[index]  : 0;
    let p = product.quantityP[index] ? product.quantityP[index]  : 0;
    let u = product.quantityU[index] ? product.quantityU[index]  : 0;
    return (l * product.purchasePacking) + (p * product.loadPacking) + u;
  }
  //------------------------------------------------------------------------------------------------------------


 //---------------------------------------------------------------------------------------
 print(){
  //  this.salesTransactionsService.sorderPrint(this.sorder.sorderCode)
  }

  //-----------------------------------------------------------------------------------------------------------------------------
simulate(){


  let sinvoice : Sinvoice = new Sinvoice();
  let tmp : Partner = new Partner();
  tmp.partnerCode = this.sorder.partner.partnerCode;
  sinvoice.partner = tmp;
  sinvoice.periodActiveDay = this.sorder.periodActiveDay;

  let sorderTmp : Sorder = new Sorder();
  sorderTmp.sorderCode = this.sorder.sorderCode;
  sinvoice.sorder = sorderTmp;

  sinvoice.sinvoiceLines = [];
  this.masterDataService.salableProductPages.forEach(pp => {
      pp.products.forEach(p => {
        if (p.quantityP[2] == null)  p.quantityP[2] = 0;     // TODO
        if (p.quantityU[2] == null)  p.quantityU[2] = 0;
          if (p.quantityP[2] || p.quantityU[2]) {
              let sinvoiceLine : SinvoiceLine = new SinvoiceLine();
              sinvoiceLine.product = new Product();
              sinvoiceLine.sinvoiceLineNumber         = 0; // required, otherwise Json parsing pb on server side !!
              sinvoiceLine.product.productCode      = p.productCode;
              sinvoiceLine.product.name             = p.name;
              sinvoiceLine.quantity                 = p.quantityP[2] * p.salesPacking +  p.quantityU[2] ;
              sinvoiceLine.returnedQuantity         = 0;
              sinvoiceLine.returnedDamagedQuantity1 = 0;
              sinvoiceLine.returnedDamagedQuantity2 = 0; 
              sinvoiceLine.unitPrice                = p.salesPrice;
              sinvoiceLine.freeGoodLine             = false;
              sinvoice.sinvoiceLines.push(sinvoiceLine);
          }
      })
  })

this.simulatedInvoice = sinvoice;
  this.salesTransactionsService.sinvoiceSimulate(sinvoice).then(result => {
      this.sinvoice = result;
      this.validationStep = true;
  })
}
//-----------------------------------------------------------------------------------------------------------------------------

simulatedInvoice : Sinvoice;
//-----------------------------------------------------------------------------------------------------------------------------
validate(){
  this.salesTransactionsService.sinvoiceCreate(this.simulatedInvoice).then(result => {
    this.sinvoice = result;
    this.validationStep = false;
    this.leanUtilsService.success();
    this.sorder.edit    = false;
    this.salesTransactionsService.sorderGet(this.sorder.sorderCode).then(result => {
      this.sorder = result;
      this.setEntity(this.sorder);
  })

  })
}
//-----------------------------------------------------------------------------------------------------------------------------

}

